// common localized variables that are different in US, CA, UK, IE
export const localeName = "USA"; 
export const color = "color";
export const colorCapitalized = "Color";
export const phoneNumber = "1-877-446-7746";
export const quartzPath = "//cdn.4imprint.com/qtz";
export const productImagePath = "https://cdn.4imprint.com/prod";
export const regSM = "&reg;";
export const certainDeliveryParagraph = "It's on time or it's on us. If your event is missed because we didn't ship on time, your order is free.";
export const certainHappinessParagraph = "If you're not 100% satisfied with your order, we'll pay to pick it up and rerun it or refund your money—your choice.";